import { RouteRecordRaw } from 'vue-router'

const productsetCreationRoutes: RouteRecordRaw[] = [
  {
    path: 'productsets/create/:templateId?',
    name: 'ProductsetCreation',
    component: () =>
      import('@/views/ProductsetCreation/ProductSetCreation.vue'),
    meta: {
      title: 'Create Product Set'
    },
    beforeEnter: async (to, from, next) => {
      if (!to.params.templateId) {
        next()
      }

      const templateId = Number(to.params.templateId)
      if (isNaN(templateId) || templateId <= 0) {
        next({ name: 'NotFound' })
      } else {
        next()
      }
    }
  },
  {
    path: 'productsets/clone/:productSetId',
    name: 'ProductsetClone',
    component: () =>
      import('@/views/ProductsetCreation/ProductSetCreation.vue'),
    meta: {
      title: 'Clone Product Set',
      bpSwitchFallback: 'ProductSet'
    },
    beforeEnter: async (to, from, next) => {
      const productSetId = Number(to.params.productSetId)
      if (isNaN(productSetId) || productSetId <= 0) {
        next({ name: 'NotFound' })
      } else {
        next()
      }
    }
  },
  {
    path: 'productsets/update/:id',
    name: 'ProductsetUpdate',
    component: () =>
      import('@/views/ProductsetCreation/ProductSetCreation.vue'),
    meta: {
      title: 'Update Product Set',
      bpSwitchFallback: 'ProductSet'
    },
    beforeEnter: async (to, from, next) => {
      const productSetId = Number(to.params.id)
      if (isNaN(productSetId) || productSetId <= 0) {
        next({ name: 'NotFound' })
      } else {
        next()
      }
    }
  },
  {
    path: 'productsets/preview/:id',
    name: 'ProductsetPreview',
    component: () =>
      import('@/views/ProductsetCreation/ProductSetCreation.vue'),
    meta: {
      title: 'Product Set Preview',
      bpSwitchFallback: 'ProductSet'
    },
    beforeEnter: async (to, from, next) => {
      const productSetId = Number(to.params.id)
      if (isNaN(productSetId) || productSetId <= 0) {
        next({ name: 'NotFound' })
      } else {
        next()
      }
    }
  }
]

export default productsetCreationRoutes
